import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, UserProfileImage } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useUser, { generateUrls, useRelations } from '@hooks/useUser'

import type { UserModel } from '@domain-group/realhub-backend-api-types'

const UserListItem = (props: { agencyId: number, user: UserModel }) => {
  const { agencyId, user } = props

  const userPayload = useUser(user)
  const {
    user: {
      email, full_name, mobile_number,
    },
  } = userPayload

  const urls = generateUrls(user, { prefixRoute: `agencies/${agencyId}/manage` })
  const { editUserUrl } = urls

  const { image } = useRelations(user)
  const imageUrl = digObject(image, 'thumb_url')

  return (
    <DashboardModuleListItem
      href={editUserUrl}
      imageComponent={(
        <UserProfileImage
          boxProps={{ backgroundSize: 'contain', borderRadius: 50, width: 30 }}
          imageUrl={imageUrl}
        >
          <FontAwesomeIcon icon={faUser} />
        </UserProfileImage>
      )}
      imageVariant="square"
      title={full_name}
      secondaryText={email}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {mobile_number}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default UserListItem
